import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config";
import i18n from "../../../functions/i18next";

export default {
  data() {
    return {
      company_full: this.$store.state.company_full,
      email: "",
      param_fullname: "",
      request_fullname: "",
      param_tel: "",
      param_company: "",
      param_address: "",
      param_country: "",
      param_field: "",
      message: "",
      roles: [],
      role: i18n.t("manage_users.select_role"),
      added: false,
      error: false,
      showRoles: false,
      disabled: true,
      emails: [],
    };
  },
  created() {
    this.getRoles();
    this.getAllUsers();

    var urlParams = new URLSearchParams(window.location.search);

    if (urlParams.has("inviterequested")) {
      this.email = urlParams.get("inviterequested");
      this.params = urlParams.get("params");
      this.request_fullname = urlParams.get("Full Name");
      this.param_fullname = urlParams.get("Full Name");
      this.param_tel = urlParams.get("Tel");
      this.param_company = urlParams.get("Company");
      this.param_address = urlParams.get("Address");
      this.param_country = urlParams.get("Country");
      this.param_field = urlParams.get("Field");
      EventBus.$emit("inviterequested");
    }
  },
  methods: {
    /**
     * Get the existing users
     */
    getAllUsers() {
      this.$axios.get(baseUrl + "/companyusers").then((response) => {
        let users = response.data;
        for (let user in users) {
          this.emails.push(users[user].email);
        }
      });
    },
    /**
     * Get the roles
     */
    getRoles() {
      this.$axios.get(baseUrl + "/companyroles").then((response) => {
        let values = response.data;
        for (let value in values) {
          let role = [];
          role.id = values[value].id;
          role.company_id = values[value].company_id;
          role.name = values[value].name;
          this.roles.push(role);
        }
      });
    },
    /**
     * Set the active role
     */
    setRole(name, id) {
      this.role = name;
      this.role_id = id;
      this.showRoles = false;
      this.setDisabled();
    },
    /**
     * Check if the button should be disabled or enabled
     */
    setDisabled() {
      this.error = false;
      this.message = false;

      if (
        this.role != i18n.t("manage_users.select_role") &&
        this.email != "" &&
        this.email.includes("@")
      ) {
        this.disabled = false;
      } else {
        this.disabled = true;
      }
    },
    /**
     * Add the user as a basic user
     */
    addUser: function () {
      let found = this.emails.includes(this.email);

      if (!found) {
        let formData = new FormData();

        formData.append("mail", this.email);
        formData.append("fullname", this.param_fullname);
        formData.append("tel", this.param_tel);
        formData.append("address", this.param_address);
        formData.append("company", this.param_company);
        formData.append("country", this.param_country);
        formData.append("field", this.param_field);
        formData.append("role_id", this.role_id);

        this.$axios
          .post(baseUrl + "/invite", formData)
          .then((response) => {
            if (response.data) {
              this.added = true;
              this.message = i18n.t("manage_users.user_added");
              var urlParams = new URLSearchParams(window.location.search);
              if (urlParams.has("inviterequested")) {
                let query = Object.assign({}, this.$route.query);
                delete query.inviterequested;
                this.$router.replace({ query });
              }
              EventBus.$emit("get-all-users");
              setTimeout(function () {
                this.refresh();
              }, 100);
            } else {
              this.error = true;
              this.message = i18n.t("common.something_went_wrong");
            }
          })
          .catch((thrown) => {
            this.error = true;
            this.message = i18n.t("common.something_went_wrong");
          });
      } else {
        this.error = true;
        this.message = i18n.t("manage_users.user_exists");
      }
    },
    /**
     * Open the add new role section
     */
    addNewRole() {
      this.showRoles = false;
      this.disabled = true;
      this.role = i18n.t("manage_users.select_role");
      this.email = "";
      EventBus.$emit("open-manage-user-actions", "add-role");
    },
    /**
     * Close the user add screen
     */
    close() {
      this.showRoles = false;
      this.disabled = true;
      this.role = i18n.t("manage_users.select_role");
      this.email = "";
      EventBus.$emit("close-manage-user-actions");
    },
  },
};
